<div>
  <header-with-menu [braintreeDefaultCountry]="braintreeDefaultCountry" [showLogo]="showHeaderLogo" [icon]="brandLogo"
    [showContent]="showHeaderContent" [headerText]="headerText" [showOnOrderForm]="showOnOrderForm"></header-with-menu>

  <div class="topCartDelay" *ngIf="noticeOn">
    <div>
      <div col-12 [innerHTML]="noticeText"></div>
    </div>
  </div>
  
  <section id="orderForm-validation-error-box" class="errors">
    <div class="errors__row" *ngIf="!couponValidation">
      <div col-12 class="errors__col">
        <ul class="errors__list">
          <li *ngIf="!couponValidation" class="errors__item">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text"
              [innerHTML]="getLabelCheckout('couponinvalid') ? getLabelCheckout('couponinvalid') : 'Sorry, the coupon code you have entered is invalid. Please check the code and try again.'">Sorry,
              the <strong>coupon code</strong> you have entered is invalid. Please check
              the code and try again.</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="errors__row" *ngIf="
      (submittedAccountForm || submittedPaymentForm) &&
      (
        (accountForm && accountForm.invalid) ||
        (accountForm && accountForm.valid && accountForm.controls && accountForm.controls['state'] && accountForm.controls['state'].value === '' && statesList && statesList.length > 0) ||
        (braintreeEnabled && braintreeInstance && ((braintreeDropInEnabled && !braintreeDropinValid) || (!braintreeHostedFieldsValid && !braintreePayPalTokenizedPayment ) )) ||
        (!isSelectedCB2 && diffAddress && diffAddress.invalid) ||
        (paymentForm && paymentForm.invalid && !braintreePayPalTokenizedPayment) ||
        rejectOrder
      )
    ">
      <!-- Currently, we have a temporary fix for red border showing at the top even we have a successfull transaction. Need to refactor the ngIf above to figure out which conditions needs to be modified. -->
      <div col-12 class="errors__col"
        [ngClass]="{ 'errors__col--noBorder': (!accountForm.invalid && !paymentForm.invalid && !diffAddress?.invalid && !rejectOrder) }">
        <p *ngIf="!rejectOrder && accountForm.invalid" class="errors__info"
          [innerHTML]="getLabelCheckout('pleasecheck') ? getLabelCheckout('pleasecheck') : 'Please check the following errors'">
          Please сheck the following errors</p>
        <ul class="errors__list">

          <!-- REJECT ORDER -->
          <li class="errors__item" *ngIf="rejectOrder">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text"><strong>{{rejectOrderMessage.header}}</strong></span>
          </li>
          <li class="errors__item" *ngIf="rejectOrder">
            <span class="errors__text">{{rejectOrderMessage.body}}</span>
          </li>

          <!-- ACCOUNT FORM -->
          <li class="errors__item"
            *ngIf="accountForm.controls['firstName'].invalid && accountForm.controls['firstName'].errors.required">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text">
              <strong>{{ getLabelCheckout('firstName') }} </strong> 
              <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
            </span> 
          </li>
          <li class="errors__item"
            *ngIf="accountForm.controls['firstName'].invalid && accountForm.controls['firstName'].errors.pattern">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text"><strong>{{ getLabelCheckout('firstName')}}</strong> {{
              getLabelCheckout('containsinvalid')}}.</span>
          </li>
          <li class="errors__item"
            *ngIf="accountForm.controls['lastName'].invalid && accountForm.controls['lastName'].errors.required">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text">
              <strong>{{ getLabelCheckout('lastName') }} </strong> 
              <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
          </span>
          </li>
          <li class="errors__item"
            *ngIf="accountForm.controls['lastName'].invalid && accountForm.controls['lastName'].errors.pattern">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text"><strong>{{ getLabelCheckout('lastName')}}</strong> {{
              getLabelCheckout('containsinvalid')}}.</span>
          </li>
          <li class="errors__item"
            *ngIf="accountForm.controls['phone'].invalid && accountForm.controls['phone'].errors.required">
            <img  src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text">
              <strong>{{ getLabelCheckout('phone') }} </strong> 
              <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
          </span>
          </li>
          <li class="errors__item"
            *ngIf="accountForm.controls['phone'].invalid && accountForm.controls['phone'].errors.pattern">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text"><strong>{{ getLabelCheckout('phone')}}</strong> {{
              getLabelCheckout('containsinvalid')}}.</span>
          </li>
          <li class="errors__item"
            *ngIf="accountForm.controls['email'].invalid && accountForm.controls['email'].errors.required">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text">
              <strong>{{ getLabelCheckout('email') }} </strong> 
              <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
          </span>
          </li>
          <li class="errors__item" *ngIf="
            accountForm.controls['email'].invalid &&
            (
              accountForm.controls['email'].errors.email ||
              accountForm.controls['email'].errors.invalidValidEmail
            ) &&
            accountForm.controls['email'].value &&
            accountForm.controls['email'].value.length > 0
          ">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text"><strong>Email</strong> {{ getLabelCheckout('address is invalid')}}.</span>
          </li>
          <li class="errors__item"
            *ngIf="accountForm.controls['confirmEmail'].invalid && accountForm.controls['confirmEmail'].errors.required">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text">
              <strong>{{ getLabelCheckout('confirmEmail') }} </strong> 
              <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
          </span>
          </li>
          <li class="errors__item" *ngIf="
            accountForm.controls['confirmEmail'].invalid &&
            (
              accountForm.controls['confirmEmail'].errors.email ||
              accountForm.controls['confirmEmail'].errors.invalidValidEmail
            ) &&
            accountForm.controls['confirmEmail'].value &&
            accountForm.controls['confirmEmail'].value.length > 0
          ">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text"><strong>{{ getLabelCheckout('confirmEmail')}}</strong> {{
              getLabelCheckout('address is invalid')}}.</span>
          </li>
          <li class="errors__item" *ngIf="
            accountForm.controls['confirmEmail'].invalid &&
            (
              accountForm.controls['email'].invalid &&
              accountForm.controls['email'].errors.invalidConfirmEmails ||
              accountForm.controls['confirmEmail'].errors.invalidConfirmEmails
            ) &&
            accountForm.controls['email'].value &&
            accountForm.controls['email'].value.length > 0 &&
            accountForm.controls['confirmEmail'].value &&
            accountForm.controls['confirmEmail'].value.length > 0
          ">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text"><strong>{{ getLabelCheckout('confirmEmail')}}</strong> does not match
              Email.</span>
          </li>
          <li class="errors__item"
            *ngIf="accountForm.controls['street'].invalid && accountForm.controls['street'].errors.required">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text">
              <strong>{{ getLabelCheckout('addressTC') }} </strong> 
              <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
          </span>
          </li>
          <li class="errors__item"
            *ngIf="accountForm.controls['street'].invalid && accountForm.controls['street'].errors.pattern">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text"><strong>{{ getLabelCheckout('addressTC')}}</strong> {{
              getLabelCheckout('containsinvalid')}}.</span>
          </li>
          <li class="errors__item"
            *ngIf="accountForm.controls['city'].invalid && accountForm.controls['city'].errors.required">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text">
              <strong>{{ getLabelCheckout('city') }} </strong> 
              <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
          </span>
          </li>
          <li class="errors__item"
            *ngIf="accountForm.controls['city'].invalid && accountForm.controls['city'].errors.pattern">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text"><strong>{{ getLabelCheckout('city')}}</strong> {{
              getLabelCheckout('containsinvalid')}}.</span>
          </li>
          <li class="errors__item"
            *ngIf="accountForm.controls['zipPostalCode'].invalid && accountForm.controls['zipPostalCode'].errors.required">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text">
              <strong>{{ getLabelCheckout('zipTC') }} </strong> 
              <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
          </span>
          </li>
          <li class="errors__item"
            *ngIf="accountForm.controls['zipPostalCode'].invalid && accountForm.controls['zipPostalCode'].errors.pattern">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text"><strong>{{ getLabelCheckout('zipTC')}}</strong> {{
              getLabelCheckout('containsinvalid')}}.</span>
          </li>
          <li class="errors__item"
            *ngIf="accountForm.controls['country'].invalid && accountForm.controls['country'].errors.required">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text">
              <strong>{{ getLabelCheckout('country') }} </strong> 
              <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
          </span>
          </li>
          <li class="errors__item"
            *ngIf="accountForm.controls['state'].value === '' && statesList && statesList.length > 0">
            <img src="{{ warningImg }}" alt="" class="errors__image">
            <span class="errors__text">
              <strong>{{ getLabelCheckout('state') }} </strong> 
              <span>Is a required {{isSelectedCB2 ? 'Shipping' : 'Billing'}} information field.</span>
          </span>
          </li>

          <!-- SHIPPING ADDRESS -->
          <div *ngIf="!isPayPalBillingAgreementApproved && buttonList[0].isPlaceOrder">
            <li class="errors__item"
              *ngIf="diffAddress?.controls?.['firstNameShipping']?.invalid && diffAddress?.controls?.['firstNameShipping']?.errors?.required">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelShipping('firstName')}}</strong> <span>
                Is a required Shipping information field</span>.</span>
            </li>
            <li class="errors__item"
              *ngIf="diffAddress?.controls?.['firstNameShipping']?.invalid && diffAddress?.controls?.['firstNameShipping']?.errors?.pattern">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelShipping('firstName')}}</strong> {{
                getLabelCheckout('containsinvalid')}}.</span>
            </li>
            <li class="errors__item"
              *ngIf="diffAddress?.controls?.['lastNameShipping']?.invalid && diffAddress?.controls?.['lastNameShipping']?.errors?.required">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelShipping('lastName')}}</strong> <span>
                Is a required Shipping information field</span>.</span>
            </li>
            <li class="errors__item"
              *ngIf="diffAddress?.controls?.['lastNameShipping']?.invalid && diffAddress?.controls?.['lastNameShipping']?.errors?.pattern">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelShipping('lastName')}}</strong> {{
                getLabelCheckout('containsinvalid')}}.</span>
            </li>
            <li class="errors__item"
              *ngIf="diffAddress?.controls?.['shipAddress']?.invalid && diffAddress?.controls?.['shipAddress']?.errors?.required">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelShipping('addressTC')}}</strong> <span>
                Is a required Shipping information field</span>.</span>
            </li>
            <li class="errors__item"
              *ngIf="diffAddress?.controls?.['shipAddress']?.invalid && diffAddress?.controls?.['shipAddress']?.errors?.pattern">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelShipping('addressTC')}}</strong> {{
                getLabelCheckout('containsinvalid')}}.</span>
            </li>
            <li class="errors__item"
              *ngIf="diffAddress?.controls?.['shipCity']?.invalid && diffAddress?.controls?.['shipCity']?.errors?.required">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelShipping('city')}}</strong> <span>
                Is a required Shipping information field</span>.</span>
            </li>
            <li class="errors__item"
              *ngIf="diffAddress?.controls?.['shipCity']?.invalid && diffAddress?.controls?.['shipCity']?.errors?.pattern">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelShipping('city')}}</strong> {{
                getLabelCheckout('containsinvalid')}}.</span>
            </li>
            <li class="errors__item"
              *ngIf="diffAddress?.controls?.['shipPostal']?.invalid && diffAddress?.controls?.['shipPostal']?.errors?.required">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelShipping('zipTC')}}</strong> <span>
                Is a required Shipping information field</span>.</span>
            </li>
            <li class="errors__item"
              *ngIf="diffAddress?.controls?.['shipPostal']?.invalid && diffAddress?.controls?.['shipPostal']?.errors?.pattern">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelShipping('zipTC')}}</strong> {{
                getLabelCheckout('containsinvalid')}}.</span>
            </li>
            <li class="errors__item"
              *ngIf="diffAddress?.controls?.['shipCountry']?.invalid && diffAddress?.controls?.['shipCountry']?.errors?.required">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelShipping('country')}}</strong> <span>
                Is a required Shipping information field</span>.</span>
            </li>
            <li class="errors__item"
              *ngIf="diffAddress?.controls?.['shipState']?.value === '' && differentAddressStatesList && differentAddressStatesList.length > 0">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelShipping('state')}}</strong> <span>
                Is a required Shipping information field</span>.</span>
            </li>
          </div>

          <!-- PAYMENT FORM -->
          <!-- This error is only for braintree hosted fields on our checkout pages so we have !enableCyberSource as one of the conditionals which implies that the checkout page fields are Braintree -->
          <div
            *ngIf="braintreeInstance && ((braintreeDropInEnabled && !braintreeDropinValid) || (!enableCyberSource && !braintreeHostedFieldsValid && !braintreePayPalTokenizedPayment && braintreeHostedFieldsErrorHandler()))">
            <li class="errors__item">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"
                [innerHTML]="getLabelCheckout('pleaseselect') ? getLabelCheckout('pleaseselect') : 'Please select a payment method'">Please
                select a payment method.</span>
            </li>
          </div>

          <!-- These errors are for credit card fields using Cybersource and non for Braintree credit card fields so we have enableCyberSource && !braintreePayPalTokenizedPayment as the conditionals -->
          <div
            *ngIf="(!braintreeInstance && !isPayPalBillingAgreementApproved && buttonList[0].isPlaceOrder) || (enableCyberSource && !braintreePayPalTokenizedPayment)">
            <li class="errors__item"
              *ngIf="submittedPaymentForm && paymentForm?.controls && paymentForm.controls['nameOnCard'] && paymentForm.invalid && paymentForm.controls['nameOnCard'].errors?.required">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelPayment('nameCard') }}</strong> <span>
                  is a required Billing information field</span>.</span>
            </li>

            <li class="errors__item"
              *ngIf="submittedPaymentForm && paymentForm?.controls && paymentForm.controls['nameOnCard'] && paymentForm.invalid && paymentForm.controls['nameOnCard'].errors?.pattern">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelPayment('nameCard')}}</strong> {{
                getLabelCheckout('containsinvalid')}}.</span>
            </li>

            <li class="errors__item"
              *ngIf="submittedPaymentForm && paymentForm?.controls && paymentForm.controls['number'] && paymentForm.invalid && paymentForm.controls['number'].errors?.required">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelPayment('cardNumber')}}</strong> <span>
                  is a required Billing information field</span>.</span>
            </li>

            <li class="errors__item"
              *ngIf="submittedPaymentForm && paymentForm?.controls && paymentForm.controls['number'] && paymentForm.invalid && paymentForm.controls['number'].errors && (paymentForm.controls['number'].errors.invalidTypeNumber || paymentForm.controls['number'].errors.invalidNumber)">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text">Invalid <strong>credit card number</strong>.</span>
            </li>

            <li class="errors__item"
              *ngIf="submittedPaymentForm && paymentForm?.controls && paymentForm.controls['expCard'] && paymentForm.controls['expCard'].errors?.required">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelPayment('monthDateTC')}}</strong> <span>
                  is a required Billing information field</span>.</span>
            </li>

            <li class="errors__item"
              *ngIf="submittedPaymentForm && paymentForm?.controls && paymentForm.controls['expCard'] && paymentForm.controls['expCard'].errors?.required">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelPayment('yearDateTC')}}</strong> <span>
                  is a required Billing information field</span>.</span>
            </li>

            <li class="errors__item" *ngIf="
              submittedPaymentForm && paymentForm?.controls && 
              paymentForm.controls['expmonth'] && paymentForm.controls['expyear'] &&
              paymentForm.invalid &&
              (
                paymentForm.controls['expmonth'].errors?.cardExpired ||
                paymentForm.controls['expyear'].errors?.cardExpired
              )
            ">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelPayment('expirationDate')}}</strong> is invalid. Card has
                expired.</span>
            </li>

            <li class="errors__item"
              *ngIf="submittedPaymentForm && paymentForm?.controls && paymentForm.controls['code'] && paymentForm.invalid && paymentForm.controls['code'].errors?.required">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelPayment('cvvTC')}}</strong> <span>
                  is a required Billing information field</span>.</span>
            </li>

            <li class="errors__item"
              *ngIf="submittedPaymentForm && paymentForm?.controls && paymentForm.controls['code'] && paymentForm.invalid && paymentForm.controls['code'].errors && (paymentForm.controls['code'].errors.minlength || paymentForm.controls['code'].errors.maxlength)">
              <img src="{{ warningImg }}" alt="" class="errors__image">
              <span class="errors__text"><strong>{{ getLabelPayment('cvvTC')}}</strong> is invalid.</span>
            </li>
          </div>
        </ul>
      </div>
    </div>
  </section>

  <section class="form__grid" [ngClass]="{'submitted__errors': (submittedAccountForm &&
  (
    (accountForm && accountForm.invalid) ||
    (accountForm && accountForm.valid && accountForm.controls && accountForm.controls['state'] && accountForm.controls['state'].value === '' && statesList && statesList.length > 0) ||
    (isSelectedCB2 && accountForm && accountForm.invalid) ||
    (braintreeEnabled && braintreeInstance && ((braintreeDropInEnabled && !braintreeDropinValid) || (!braintreeHostedFieldsValid && !braintreePayPalTokenizedPayment ) )) ||

    (isSelectedCB2 && accountForm && accountForm.valid && accountForm.controls && accountForm.controls['shipState'] && accountForm.controls['shipState'].value === '' && differentAddressStatesList && differentAddressStatesList.length > 0)  ||
    (!isSelectedCB2 && diffAddress && diffAddress.invalid) ||
    rejectOrder
  ) ||
  submittedPaymentForm &&
  (
    (paymentForm && paymentForm.invalid) ||
    rejectOrder
  ))}">

    <div class="form__row tabs tabs__col" *ngIf="braintreeCountrySelector"
      style="display:contents;cursor:pointer;font-size:small;float:right;" class="tooltip-country">
      <div class="tooltip-country-col">🌐
        <span class="tooltiptext-country">
          <p class="tooltipinnerglobe">🌐</p>
          <select style="min-width: 140px;" (change)="changeBraintreeSettings($event)">
            <ng-template ngFor let-item [ngForOf]="braintreeEUCountries" let-i="index" let-isLast="last">
              <option selected *ngIf="item == braintreeDefaultCountry">{{item}}</option>
              <option *ngIf="item != braintreeDefaultCountry">{{item}}</option>
            </ng-template>
          </select>
          <select style="min-width: 140px; margin-right:15px;" (change)="changeBraintreeCurrencySettings($event)">
            <ng-template ngFor let-item [ngForOf]="braintreeCurrencies" let-i="index" let-isLast="last">
              <option selected *ngIf="item == currency">{{item}}</option>
              <option *ngIf="item != currency">{{item}}</option>
            </ng-template>
          </select>
        </span>
      </div>
    </div>

    <div class="order_content_wrapper form__row">
      <!-- ORDER BUTTONS -->
      <article [hidden]="buttonList[0].isPlaceOrder" class="order_buttons_wrapper">
        <div class="padding0" col-12 [attr.col-md-4]="isSubscription ? true : null"
          [attr.col-md-6]="isSubscription ? null : true">
          <div id="addressBookWidgetDiv" class="amazon-widget"></div>
        </div>
        <div class="padding0" col-12 [attr.col-md-4]="isSubscription ? true : null"
          [attr.col-md-6]="isSubscription ? null : true">
          <div id="walletWidgetDiv" class="amazon-widget"></div>
        </div>
        <div class="padding0" col-12 [attr.col-md-4]="isSubscription ? true : null" [hidden]="!isSubscription">
          <div id="consentWidgetDiv" class="amazon-widget"></div>
        </div>
      </article>
      <article [hidden]="buttonList[0].isPlaceOrder" class="order_buttons_wrapper form__row">
        <div col-12 [attr.col-md-4]="isSubscription ? true : null" [attr.col-md-6]="isSubscription ? null : true">
          <div onclick="window.amazon.Login.logout();location.reload(); return false;"
            style="color:lightgray; cursor:pointer; text-decoration: underline; float: left; padding-left: 10px; font-size: x-small;">
            Amazon logout</div>
        </div>
        <div col-12 [attr.col-md-4]="isSubscription ? true : null" [attr.col-md-6]="isSubscription ? null : true">
          <div></div>
        </div>
        <div col-12 [attr.col-md-4]="isSubscription ? true : null" [hidden]="!isSubscription">
          <div></div>
        </div>
      </article>
      <article class="order_buttons_wrapper">
        <div col-12 col-lg-6 pull-lg-6 class="form_col form_col_v2">
          <div class="buttons_wrapper buttonsWrapperV2"
            [ngClass]="braintreePayPalTokenizedPayment ? 'hidden' : ''">
            <div [hidden]="!showPayPalPayButton">
              <button name="PayPal" id="order-form-paypal-button"
              *ngIf="!isPayPalBillingAgreementApproved && (!isSubscription || !isPurchaseAvailable)"
               class="paypal_button buttonsWrapperV2__paypalButton" alt="PayPal" type="submit"
              (click)="checkoutPayPalWithDifferentAddress(accountForm, diffAddress)"><img
                src="{{ iconPaypal }}" alt="PayPal" loading="eager" fetchpriority="high" decoding="sync" /></button>
                <p *ngIf="!isPayPalBillingAgreementApproved && (!isSubscription || !isPurchaseAvailable)" class="buttonsWrapperV2__standardOrderText">- Or -</p>
            </div>

            <div [hidden]="isPayPalBillingAgreementApproved || !showAmazonButton" id="AmazonPayButton"
              class="amazonpay_button buttonsWrapperV2__amazonButton"></div>

              <div [hidden]="showPayPalPayButton" class="paypalBtnContainer"
                [ngClass]="decorateBraintreePayPalButton ? 'paypalBtnContainerPlaceholderCover' : ''">
                <img [ngClass]="decorateBraintreePayPalButton ? 'paypalBtnPlaceholderCover' : 'paypalBtnPlaceholder'"
                  [src]="decorateBraintreePayPalButton ? 'https://www2.thehealthyfat.com/assets/img/paypalButton.jpg' : '/assets/img/paypalBtnPlaceholder2.png'"
                  alt="PayPal" />
                <div [hidden]="braintreeHidePayPalButton || isBraintreeLoading || !braintreeEnabled" id="paypal-button"
                  [ngClass]="decorateBraintreePayPalButton ? 'transparentButtonContainer paypal_buttonWrapper buttonsWrapperV2__paypalButtonBT' : 'paypal_buttonWrapper buttonsWrapperV2__paypalButtonBT'">
                </div>
                <p class="buttonsWrapperV2__standardOrderTextBT">-Or-</p>
              </div>
          </div>
        </div>
      </article>

      <!--ORDER DETAILS-->
      <article *ngIf="showProductBox" class="order_details_wrapper form__row  order_detail_row">
        <div col-12 class="order_detail_col">
          <div class="order_detail_table">
            <div class="order_detail_table_col">
              <div class="order_detail_title">
                <span class="form__title"
                  [innerHTML]="getLabelCheckout('orderdetail') ? getLabelCheckout('orderdetail') : 'Order Detail'">Order
                  Detail</span>
                <div class="form__title_description mt-5">
                  <span [innerHTML]="getLabelCheckout('item') ? getLabelCheckout('item') : 'Item'">Item</span>
                  <span [innerHTML]="getLabelCheckout('price') ? getLabelCheckout('price') : 'Price'">Price</span>
                </div>
              </div>
            </div>
            <hr class="order_detail_hr">
            <div class="order_detail_table_col mt-10">
              <div class="order_detail_table_col_content">
                <img class="product_img" *ngIf="currentFunnel?.subscriptionFrequency !== 'Monthly'" src={{newImage}}
                  alt="Product Image" loading="eager" fetchpriority="high" decoding="sync">
                <img class="product_img" *ngIf="currentFunnel?.subscriptionFrequency === 'Monthly'"
                  src={{currentFunnel?.product?.image[1]?.imageUrl}} alt="Product Image" loading="eager" fetchpriority="high" decoding="sync">
                <div class="form__title_wrap">
                  <div class="form__title_description">
                    <span class="order_detail_bold"></span>

                    <!-- Consolidated Generic -->
                    <span class="order_detail_price" *ngIf="totalPrice <= 0">
                      {{ ( (1 * currentFunnel?.offerPrice) + ((currentFunnel?.isFreeFirstShipping && selectedDeliveryDay
                      == 'Free' ) ? 0 : (1 * shippingCost)) + (1 * couponDiscount) ) | dynamicCurrency:currency }}
                    </span>
                    <span class="order_detail_price"
                      *ngIf="showProductBox && coupon.discountType !== 'Free Shipping' && totalPrice > 0">
                      {{ currentFunnel?.offerPrice | dynamicCurrency:currency }}
                    </span>
                  </div>
                  <div class="form__title_description mt-5">
                    <div class="product_description pl-7">
                      <span>Quantity: {{currentFunnel?.product?.description}}</span>
                    </div>
                    <span class="order_detail_price" *ngIf="currentFunnel?.subscriptionFrequency === 'Monthly'"
                      [innerHTML]="getLabelCheckout('subscription') ? getLabelCheckout('subscription') : 'Subscription'">Subscription</span>
                    <span class="order_detail_price" *ngIf="currentFunnel?.subscriptionFrequency !== 'Monthly'"
                      [innerHTML]="getLabelCheckout('onetimepurchase') ? getLabelCheckout('onetimepurchase') : 'One Time Purchase'">One
                      Time Purchase</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <!-- CUSTOMER INFORMATION -->
      <article class="customer_information_wrapper">
        <section class="customer_information_wrapper--box">
          <div class="custom-legend">Standard Checkout</div>
          <div class="form__titleWrapper">
            <div col-12 [innerHTML]="getLabelCheckout('shippingLabelTC')"></div>
          </div>
          <account-form-v2 *ngIf="this.isSelectedCB2" class="account-form_wrapper" [braintreeDefaultZipPostalCode]="braintreeDefaultZipPostalCode"
            [braintreeDefaultCountry]="braintreeDefaultCountry" [euSpecified]="euSpecified" [guest]="guest"
            (countryChange)="onCountryChange($event)"
            [statesList]="statesList" [countriesList]="countriesList" [submittedAccountForm]="submittedAccountForm"
            [emailToConfirm]="emailToConfirm"
            (validateAddressAndCalculateTaxes)="validateAddressAndCalculateTaxes($event)"
            (rememberAccountInformation)="rememberAccountInformation()" (readyToCreateLead)="readyToCreateLead()"
            (emitConfirmEmail)="emailToConfirm=$event" (linkForm)="accountForm=$event">
          </account-form-v2>
  
          <div [hidden]="isPayPalBillingAgreementApproved || !buttonList[0].isPlaceOrder">
            <!-- SHIPPING INFORMATION -->
            <div justify-content-start class="form__row  shipping_form_row" *ngIf="!this.isSelectedCB2">
              <div col-12 class="shipping_form_col">
                <shipping-form-v2 [braintreeDefaultCountry]="braintreeDefaultCountry" [euSpecified]="euSpecified"
                  [couponValidation]="couponValidation" (shipToNameBinder)="shipToName=$event"
                  [submittedAccountForm]="submittedAccountForm" [differentAddressStatesList]="differentAddressStatesList"
                  (countryChange)="onShippingCountryChange()"
                  [guest]="guest" [shipToName]="shipToName" [countriesList]="countriesList"
                  [shippingAddress]="shippingAddress"
                  (validateAddressAndCalculateTaxes)="validateAddressAndCalculateTaxes($event)"
                  (rememberAccountInformation)="rememberAccountInformation()"
                  (linkForm)="diffAddress=$event"></shipping-form-v2>              
                </div>
              </div>
            </div>
  
  
          <div [hidden]="isPayPalBillingAgreementApproved || !buttonList[0].isPlaceOrder || braintreeTokenizePaymentData" class="form__row checkbox_row">
            <div col-12 class="checkbox_col" [ngClass]="braintreeHideShipping ? 'hidden' : ''">
              <input id="toggle_addres" type="checkbox"
                (click)="changeStateCB2(); rememberAccountInformation(); handleBraintreeDefaultSetup()"
                [(ngModel)]="this.isSelectedCB2" />
              <label for="toggle_addres">{{ getLabelCheckout('diffAddressTC')}}</label>
            </div>
          </div>

          <div *ngIf="!this.isSelectedCB2" class="form__titleWrapper form__titleWrapper--billing">
            <div col-12 [innerHTML]="getLabelCheckout('billinginformationTC')"></div>
          </div>  
          <account-form-v2 class="account-form_wrapper" *ngIf="!this.isSelectedCB2" [braintreeDefaultZipPostalCode]="braintreeDefaultZipPostalCode"
            [braintreeDefaultCountry]="braintreeDefaultCountry" [euSpecified]="euSpecified" [guest]="guest"
            (countryChange)="onCountryChange($event)"
            [statesList]="statesList" [countriesList]="countriesList" [submittedAccountForm]="submittedAccountForm"
            [emailToConfirm]="emailToConfirm"
            (validateAddressAndCalculateTaxes)="validateAddressAndCalculateTaxes($event)"
            (rememberAccountInformation)="rememberAccountInformation()" (readyToCreateLead)="readyToCreateLead()"
            (emitConfirmEmail)="emailToConfirm=$event" (linkForm)="accountForm=$event">
          </account-form-v2>
  
          <div [hidden]="isPayPalBillingAgreementApproved || !buttonList[0].isPlaceOrder" class="checkbox_col checkbox_col--remember">
            <input data-qa="rem-info" class="remember-info-checkbox" type="checkbox" id="remember-pc"
              (click)="changeStatusIsRemembered()" tappable [checked]="isRememberInfoChecked" />
            <label for="remember-pc" id="remember-info"
              [innerHTML]="getLabelCheckout('remember') ? getLabelCheckout('remember') : 'Remember my Information'">Remember
              my Information</label>
          </div>
          <!-- <div class="comodo_wrapper">
  
          <!-- PAYMENT INFORMATION -->
          <section [hidden]="isBraintreeLoading || isPayPalBillingAgreementApproved || !buttonList[0].isPlaceOrder" class="payment_information_wrapper">
  
            <!-- PAYMENT INFORMATION -->
            <div class="form__row " [ngClass]="braintreePayPalTokenizedPayment ? 'hidden' : ''">
              <div col-12 [innerHTML]="getLabelCheckout('paymentInformationTC')"></div>
            </div>

            <div class="secureText"><svg fill="#515862" height="20px"
                viewBox="0 -960 960 960" width="20px" xmlns="http://www.w3.org/2000/svg">
                <path _ngcontent-pbt-c2=""
                  d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm0-80h480v-400H240v400Zm240-120q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80ZM240-160v-400 400Z">
                </path>
              </svg>
              <p _ngcontent-pbt-c2="">Encrypted and Secured</p>
            </div>

            <div class="form__row  payment_row"
              [ngClass]="braintreePayPalTokenizedPayment ? 'hidden' : ''">
              <div col-12 class="payment_col">

                <div [hidden]="!braintreeClientToken" class="braintree-card-row hidden">
                  <div class="payment_form_col col" col-12="">
                    <div [hidden]="!braintreeClientToken" id="dropin-container"></div>
                    <div [hidden]="!braintreeClientToken" id="dropin-container-paypal" style="display:none;">
                      <div (click)="whatispaypal()" class="braintree-dropin braintree-loaded">
                        <div style="padding:10px;cursor:pointer;">Paying with PayPal</div>
                        <div data-braintree-id="methods-container" class="braintree-methods--active">
                          <div class="braintree-method braintree-method--active" tabindex="0" role="button">
                            <div class="braintree-method__icon-container braintree-method__delete-container">
                              <div class="braintree-method__icon braintree-method__delete">
                                <svg width="48" height="29">
                                  <use xlink:href="#iconX"></use>
                                </svg>
                              </div>
                            </div>
  
                            <div class="braintree-method__logo">
                              <svg width="40" height="24" class="">
                                <use xlink:href="#logoPayPal"></use>
                              </svg>
                            </div>
  
                            <div class="braintree-method__label">{{ braintreePayPalEmail }}<br>
                              <div class="braintree-method__label--small">PayPal</div>
                            </div>
  
                            <div class="braintree-method__icon-container braintree-method__check-container">
                              <div class="braintree-method__icon braintree-method__check">
                                <svg height="100%" width="100%">
                                  <use xlink:href="#iconCheck"></use>
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div data-braintree-id="toggle" class="braintree-large-button braintree-toggle" tabindex="0"
                          role="button">
                          <span (click)="braintreeChooseAnotherWayToPay($event)">Remember my information and choose
                            another way
                            to
                            pay</span>
                        </div>
                      </div>
                    </div>
                    <a [hidden]="braintreeDropinValid || !braintreeDropInEnabled" class="item_link_bt_dr  braintreelink"
                      (click)="navigateToPageByGenericUrl('/what-is-this', 'name', 'width=500,height=330')"
                      href="/what-is-this">What is this?</a>
  
                  </div>
                </div>
  
                <div [hidden]="!braintreeClientToken || braintreeDropInEnabled || enableCyberSource"
                  id="dropin-container-hosted-fields" class="dropin-container-hosted-fields braintree-card-row form__row  payment_row">
  
                  <div class="payment_form_row formBT2">
                    <div size="12" class="payment_form_col">
                      <form class="btpayment_form" id="paymentForm" novalidate>
  
                        <div class="form_item_wrapper btrow btfirstrow nameOnCardBTerrorWrapper">
                          <label class="form_item_label" for="nameOnCardBT">{{ getLabelPayment('nameCard') }}</label>
                          <div class="form_item_elements btelements">
                            <div id="nameOnCardBT" class="inputBT"></div>
                            <div id="nameOnCardBTerror" class="hidden">
                              <img alt="field needs attention" src="/assets/img/icon-warning-pointer.gif">
                            </div>
                          </div>
                        </div>
  
                        <div class="form_item_wrapper btrow hidden">
                          <label class="form_item_label" for="typeOfCardBT">{{ getLabelPayment('cardType') }}</label>
                          <div class="form_item_elements  btelements">
  
                            <select class="item_select item_cartType" fixscrollonmobileios="" id="typeOfCardBT"
                              name="typeOfCard" required="">
                              <option value="visa">Visa</option>
                              <option value="mastercard">Mastercard</option>
                              <option value="amex">Amex</option>
                            </select>
  
                          </div>
                        </div>
  
                        <div class="form_item_wrapper btrow cardNumberBTerrorWrapper">
                          <label class="form_item_label" for="cardNumberBT">{{ getLabelPayment('cardNumber') }}</label>
                          <div class="form_item_elements btelements">
                            <div id="cardNumberBT" class="inputBT"></div>
                            <div id="cardNumberBTerror" class="hidden">
                              <img alt="field needs attention" src="/assets/img/icon-warning-pointer.gif">
                            </div>
                          </div>
                        </div>
  
                        <div class="exp-cvv-wrapper">
                          <div class="form_item_wrapper btrow btrowhalf expirationDateBTerrorWrapper">
                            <label class="form_item_label" for="expirationDateBT">{{ getLabelPayment('expirationDate')
                              }}</label>
                            <div class="form_item_elements btelements">
                              <div id="expirationDateBT" class="inputBT"></div>
                              <div id="expirationDateBTerror" class="hidden">
                                <img alt="field needs attention" src="/assets/img/icon-warning-pointer.gif">
                              </div>
                              <span class="item_info_bt hidden">{{ getLabelPayment('expirationDateLabelBT')}}</span>
                            </div>
                          </div>
    
                          <div class="form_item_wrapper btrow btrowhalf form_item_code btlastrow cvcCodeBTerrorWrapper">
                            <label class="form_item_label" for="cvcCodeBT">{{ getLabelPayment('cvv') }}</label>
                            <div class="form_item_elements btelements">
                              <div id="cvcCodeBT" class="inputBT"></div>
                              <div id="cvcCodeBTerror" class="hidden">
                                <img alt="field needs attention" src="/assets/img/icon-warning-pointer.gif">
                              </div>
                              <a class="new_item_link" (click)="navigateToPageByGenericUrl('/what-is-this', 'name', 'width=500,height=330')" href="/what-is-this">{{ getLabelPayment('whatsThis') }}</a>
                            
                            </div>
    
                          </div>
                        </div>
                      </form>
  
                    </div>
                  </div>
                </div>
  
                <payment-form-v2 [braintreeDefaultCountry]="braintreeDefaultCountry"
                  [hidden]="braintreeClientToken && !enableCyberSource" [cardName]="cardName" [cardType]="cardType"
                  (linkForm)="paymentForm=$event" [cardDetails]="cardDetails"
                  [submittedPaymentForm]="submittedPaymentForm" [monthArray]="monthArray"
                  [yearArray]="yearArray"></payment-form-v2>
              </div>
            </div>
          </section>
        </section>

        <!-- COMMENTS -->
        <div class="form__row  form_row_comments">
        </div>
        <div class="form__row  comment_row">


          <div *ngIf="braintreeDefaultCountry == 'Germany'" class="content_col">
            <p>Indem Sie auf "Bestellung abschicken" klicken, erklären Sie sich mit den Allgemeinen
              <a (click)="navigateToPageByGenericUrl('https://roundhouseprovisions.com/terms-and-conditions/', 'name', 'width=400,height=400')"
                target="_blank"><u>Geschäftsbedingungen</u></a> und
              <a (click)="navigateToPageByGenericUrl('../PrivacyPolicy', 'name', 'width=400,height=400')"
                target="_blank">
                <u>der Datenschutzrichtlinie</u></a> von Roundhouse Provisions einverstanden.
            </p>
            <p>*Dies ist ein geschätzter Umrechnungskurs, der Ihnen zur Verfügung gestellt wird. Ihr tatsächlicher
              Umrechnungskurs wird von Ihrer Bank festgelegt.</p>
          </div>

          <div *ngIf="braintreeDefaultCountry == 'Mexico'" class="content_col">
            <p>Al enviar su pedido a través del Sitio, acepta regirse y cumplir <a
                onclick="window.open('https://roundhouseprovisions.com/terminos-y-condiciones/', 'name','width=400,height=400')"
                style="display: inline" target="_blank"><u>los Términos y condiciones</u></a> e <a
                (click)="navigateToPageByGenericUrl('../PrivacyPolicy', 'name', 'width=400,height=400')"><u>la Política
                  de
                  privacidad</u></a> de Roundhouse Provisions.
            </p>
          </div>


          <div col-12 class="subscription_terms_wrapper content_col">
            <div class="showTerms">
              <p>By clicking Submit Order, you agree to Roundhouse Provision's <a
                  href="https://roundhouseprovisions.com/terms/" target="_blank">Terms & Conditions</a>
                and <a href="https://roundhouseprovisions.com/privacy/" target="_blank"
                  class="footer__link">Privacy Policy</a>.</p>
              <div *ngIf="isSubscription" class="showTerms_subTerms">
                <p><b>Subscription Terms:</b> This is an automatically renewing subscription. By clicking Submit Order, you also agree to our <a target="_blank"
                    href="https://cdn.roundhouseprovisions.com/continuitiy/roundhouse-terms.html">Subscription
                    Terms</a> and
                  authorize us to charge {{ ((isSubscription && !isPurchaseAvailable ? funnel.subscriptionPrice ?? 0 :
                  funnel.offerPrice ?? 0)) | dynamicCurrency:currency }} plus applicable taxes every {{ funnel.subscriptionFrequency | subscriptionTermsDaysFrequency }} to your selected payment method. Your subscription renews every {{ funnel.subscriptionFrequency | subscriptionTermsDaysFrequency }} and continues until canceled. You may cancel at any time via the <a target="_blank"
                    href="https://cart.roundhouseprovisions.com/subscription-edit">Subscription Page</a> in My Account or by
                  emailing <a target="_blank" href="mailto:support@roundhouseprovisions.com">support&#64;roundhouseprovisions.com</a>.</p>
              </div>
            </div>
          </div>
          <div col-12 class="button_wrapper button_col">
            <!-- Non-Braintree SUBMIT ORDER button. So credit card fields uses Cybersource -->
            <!-- braintreeClient Token will be present on all braintree pages when BT is on paypal button or the credit card fields are BT -->
            <!-- enableCyberSource is new variable we are using when we are combining BT paypal and Cybersource for credit card field on our page -->
            <!-- braintreePayPalTokenizedPayment will be null on page load as we only get the token when there's a BT paypal payment. That's why we have protected it by pairing with braintreeClientToken-->
            <!-- We have used [hidden] instead of ngIf as we are switching the non-BT SUBMIT ORDER button with BT SUBMIT ORDER button below when we have a paypal BT transaction -->
            <button
              [hidden]="braintreeClientToken && !enableCyberSource || (braintreeClientToken && braintreePayPalTokenizedPayment)"
              id="order-form-submit-btn" type="submit"
              [disabled]="(!buttonList[0].isPlaceOrder && isConsentStatus) || (!termsAgreed && submitOrderCheckBox) || isBraintreeLoading"
              (click)="isPayPalBillingAgreementApproved ?
                submitPayPalOrder(accountForm) :
                buttonList[0].isPlaceOrder ?
                onPayWithDifferentAddressClicked(accountForm, paymentForm, diffAddress) :
                submitAmazonPay(accountForm)"
              [innerHTML]="getLabelCheckout('submitorder') ? getLabelCheckout('submitorder') : 'Submit Order'">Submit
              Order
            </button>

            <!-- Straight up Braintree SUBMIT ORDER button -->
            <button [hidden]="!braintreeClientToken || (enableCyberSource && !braintreePayPalTokenizedPayment)"
              id="order-form-submit-btn" type="submit"
              [disabled]="(!buttonList[0].isPlaceOrder && isConsentStatus) || (!termsAgreed && submitOrderCheckBox) || isBraintreeLoading"
              (click)="payWithBrainTree(accountForm, diffAddress)"
              [innerHTML]="getLabelCheckout('submitorder') ? getLabelCheckout('submitorder') : 'Submit Order'">Submit
              Order
            </button>
          </div>

          <div *ngIf="showFeatures" class="features features--mobile">
            <div class="mbgArea feature"><img
                src="https://cdn.roundhouseprovisions.com/images/90day_guarantee_comp.png"
                alt="Money Back Guarantee icon" class="mbg">
              <p>90 Day Money Back Guarantee</p>
            </div>
            <div *ngIf="unitsSold > 0" class="unitSoldArea feature"><img
                src="https://cdn.roundhouseprovisions.com/images/DEV-19089/FlagIcon.png" alt="Flag icon"
                class="unitFlag">
              <p>Over {{ unitsSold | unitsSoldFormat }} units sold</p>
            </div>
            <div *ngIf="(isFreeChecked && (+shippingRateIndex === 0) ? 0 :
            ((shippingCost ? +shippingCost: 0) + (calculatedShippingCost ? +calculatedShippingCost : 0)
            )) == 0" class="truck feature"><img src="https://cdn.roundhouseprovisions.com/images/Truck.png"
                alt="Truck icon" class="truck">
              <p>Fast and Free Shipping</p>
            </div>
          </div>
        </div>
      </article>

      <!-- ORDER DETAILS -->
      <article class="order_details_wrapper">
        <section class="form__row  billing_form_row">
          <div col-12 col-md-12 no-padding class="total_col">

            <div [hidden]="isBraintreeLoading" class="price_button" col-lg-12 col-12>
              <!-- NON-showProductBoxVariant1 ORDER DETAILS INTERNATIONAL (DYNAMIC CURRENCY) -->
              <div *ngIf="!showProductBoxVariant1" class="table_coupon_wrapper" col-lg-6>
                <div class="table_wrapper" style="flex-direction: column;">
                  <!-- Default -->
                  <table [ngClass]="braintreeEnabled ? 'tablepadding' : ''">
                    <tr *ngIf="!hideRegularPrice">
                      <td>{{ getLabelCheckout('Regular Price') }}:</td>
                      <td class="table_regularPrice">{{ (funnel && funnel.standardPrice ? funnel.standardPrice : (funnel
                        &&
                        funnel.offerPrice ? funnel.offerPrice : 1)) | dynamicCurrency:currency }}</td>
                    </tr>
                    <tr class="table_savings" *ngIf="!hideSavings">
                      <td>{{ getLabelCheckout('Savings') }}:</td>
                      <td>-{{ ((funnel && funnel.standardPrice && funnel.offerPrice ? (funnel.standardPrice -
                        funnel.offerPrice) : 1)) | dynamicCurrency:currency }}</td>
                    </tr>
                    <tr class="table_regularPrice" *ngIf="showSubtotal">
                      <td [innerHTML]="getLabelCheckout('showsub') ? getLabelCheckout('showsub') : 'Subtotal:'">{{
                        getLabelCheckout('showSubtotal') }}:</td>
                      <td>{{ ((funnel && funnel.offerPrice && funnel.offerPrice ? funnel.offerPrice : 1)) |
                        dynamicCurrency:currency }}</td>
                    </tr>
                    <tr class="table_tax" *ngIf="!priceWithTax && funnelOffersData[0]">
                      <td>{{ getLabelCheckout('Sales Tax') }} <span class="tooltip">&nbsp;&#9432; <span
                            class="tooltiptext">Tax estimated for a shipping address in the {{ braintreeDefaultCountry
                            }}.</span></span>:</td>
                      <td *ngIf="braintreeClientToken">{{ (totalTax) | dynamicCurrency:currency }} </td>
                      <td *ngIf="!braintreeClientToken">{{ ((!funnelOffersData[0].isPurchaseAvailable &&
                        funnelOffersData[0].isSubscriptionAvailable &&
                        !isPayPalSubscription) ? subscriptionTax : (!funnelOffersData[0].isFreeFirstShipping ? totalTax
                        :
                        (isPayPalSubscription ? totalTax : subscriptionTax))) | dynamicCurrency:currency }}</td>
                    </tr>

                    <tr>
                      <td>{{ getLabelCheckout('Shipping') }}:</td>
                      <td>{{ ((funnel.isFreeFirstShipping && selectedDeliveryDay == 'Free' ) ? 0 : ((1 * shippingCost) +
                        (1
                        *
                        calculatedShippingCost))) | dynamicCurrency:currency }}</td>
                    </tr>
                    <tr *ngIf="coupon.discountAmount">
                      <td>{{ getLabelCheckout('Coupon discount') }}:</td>
                      <td>{{ (couponDiscount) | dynamicCurrency:currency }}</td>
                    </tr>

                    <tr class="total" *ngIf="getBraintreeTaxEstimate() == 0">
                      <td>{{ getLabelCheckout('Total') }}<span *ngIf="currency !== 'USD'"> (w/ {{
                          getLabelCheckout('Sales Tax') }})</span>:</td>

                      <td *ngIf="priceWithTax">{{ (funnel && funnel.offerPrice || 1) + ((funnel.isFreeFirstShipping &&
                        selectedDeliveryDay === 'Free') ? 0 : shippingCost) + couponDiscount | dynamicCurrency:currency
                        }}
                        {{ currency !== 'USD' ? currency : '' }}</td>
                      <td *ngIf="!priceWithTax">{{ (funnel && funnel.offerPrice || 1) + ((funnel.isFreeFirstShipping &&
                        selectedDeliveryDay === 'Free') ? 0 : shippingCost) + couponDiscount + totalTax |
                        dynamicCurrency:currency }} {{ currency !== 'USD' ? currency : '' }}</td>
                      <!-- <td *ngIf="coupon.discountType !== 'Free Shipping' && totalPrice > 0">{{ (totalPrice) |
                    dynamicCurrency:currency  }} {{ currency !== 'USD' ? currency : '' }}</td> -->
                    </tr>
                  </table>
                </div>

                <!-- Coupon -->
                <div class="coupon_wrapper" *ngIf="!isPayPalBillingAgreementApproved">
                  <label for="order-form-coupon-input">{{ getLabelCheckout('couponMessage')}} <i>{{
                      getLabelCheckout('optional')}}</i>:</label>
                  <div class="elements_wrapper">
                    <input id="order-form-coupon-input" [(ngModel)]="couponCode" type="text" fixScrollOnMobileiOS
                      (change)="sanitizeCouponCode()" data-qa="coupon-field" />
                    <button data-qa="coupon-apply" (click)="getCoupon()">{{getLabelCheckout('Apply')}}</button>
                  </div>
                </div>
              </div>

              <!-- PRODUCT SUMMARY BOX NON-INTERNATIONAL -->
              <div *ngIf="showProductBoxVariant1" class="table_coupon_wrapper-v2 productBoxV2">
                <div class="productBoxV2__orderSummary">
                  <h3 class="productBoxV2__orderSummary--title hidden-mobile">Order Summary</h3>
                  <div class="productBoxV2__orderBox">
                    <img class="productBoxV2__productImg" src={{productImage}} alt="Product Image" loading="eager" fetchpriority="high" decoding="sync">
                    <p class="productBoxV2__description">{{currentFunnel?.product?.description}}<br>
                      <span class="subscription-type">{{ isSubscription ? '' : 'One time purchase' }}</span>
                    </p>
                    <p class="productBoxV2__orderPrice">
                      <ng-container *ngIf="enableDisplayStandardPrice">
                        <s>{{ (funnel && funnel.standardPrice ? funnel.standardPrice : 0) | dynamicCurrency:currency }}</s>
                        <br />
                      </ng-container>
                      <span *ngIf="isSubscription && !isPurchaseAvailable">{{ currentFunnel.subscriptionPrice |
                        dynamicCurrency:currency }}</span>
                      <span *ngIf="!isSubscription || isPurchaseAvailable">{{ currentFunnel?.offerPrice |
                        dynamicCurrency:currency }}</span>
                    </p>
                  </div>
                  <hr>
                  <div class="productBoxV2__lineItem">
                    <p>Subtotal</p>
                    <p *ngIf="isSubscription && !isPurchaseAvailable">{{ currentFunnel?.subscriptionPrice |
                      dynamicCurrency:currency }}</p>
                    <p *ngIf="!isSubscription || isPurchaseAvailable">{{ currentFunnel?.offerPrice |
                      dynamicCurrency:currency }}</p>
                  </div>
                  <div *ngIf="!priceWithTax" class="productBoxV2__lineItem">
                    <p>Sales Tax</p>
                    <p>{{ ((isSubscription && !isPurchaseAvailable && !isFreeChecked) ? subscriptionTax : totalTax) |
                      dynamicCurrency:currency }}</p>
                  </div>
                  <div class="productBoxV2__lineItem">
                    <p>Shipping</p>
                    <p class="productBoxV2__lineItem--shipping">
                      <ng-container
                        *ngIf="(isFreeChecked && (+shippingRateIndex === 0) ? 0 : ((shippingCost ? +shippingCost: 0) + (calculatedShippingCost ? +calculatedShippingCost : 0))) !== 0">
                        {{ (isFreeChecked && (+shippingRateIndex === 0) ? 0 : ((shippingCost ? +shippingCost: 0) +
                        (calculatedShippingCost ? +calculatedShippingCost : 0))) | dynamicCurrency:currency }}
                      </ng-container>
                      <ng-container
                        *ngIf="(isFreeChecked && (+shippingRateIndex === 0) ? 0 : ((shippingCost ? +shippingCost: 0) + (calculatedShippingCost ? +calculatedShippingCost : 0))) == 0">FREE
                      </ng-container>
                    </p>
                  </div>
                  <hr>
                  <div *ngIf="!priceWithTax" class="productBoxV2__totalLine">
                    <b>
                      <p>Total</p>
                    </b>
                    <b>
                    <p class="productBoxV2__totalNumber">{{ (funnel && funnel.offerPrice &&
                      funnel.offerPrice ? funnel.offerPrice + productTax + shippingCost + shippingTax : 1) |
                      dynamicCurrency:currency }} {{ currency !== 'USD' ? currency : '' }}</p>
                    </b>
                  </div>
                  <div *ngIf="priceWithTax" class="productBoxV2__totalLine">
                    <b><p>Total</p></b>
                    <p class="order_detail_price productBoxV2__totalNumber">{{ (funnel && funnel.offerPrice && funnel.offerPrice ? funnel.offerPrice + shippingCost : 1) | dynamicCurrency:currency }} {{ currency !== 'USD' ? currency : '' }}</p>
                  </div>
                </div>
                <div *ngIf="showFeatures" class="features features--desktop">
                  <div class="mbgArea feature"><img
                      src="https://cdn.roundhouseprovisions.com/images/90day_guarantee_comp.png"
                      alt="Money Back Guarantee icon" class="mbg">
                    <p>90 Day Money Back Guarantee</p>
                  </div>
                  <div *ngIf="unitsSold > 0" class="unitSoldArea feature"><img
                    src="https://cdn.roundhouseprovisions.com/images/DEV-19089/FlagIcon.png" alt="Flag icon"
                    class="unitFlag">
                    <p>Over {{ unitsSold | unitsSoldFormat }} units sold</p>
                  </div>
                  <div *ngIf="(isFreeChecked && (+shippingRateIndex === 0) ? 0 :
                  ((shippingCost ? +shippingCost: 0) + (calculatedShippingCost ? +calculatedShippingCost : 0)
                  )) == 0" class="truck feature"><img src="https://cdn.roundhouseprovisions.com/images/Truck.png"
                      alt="Truck icon" class="truck">
                    <p>Fast and Free Shipping</p>
                  </div>
                </div>
              </div>

              <!-- NON-showProductBoxVariant1 BUTTONS -->
              <div *ngIf="!showProductBoxVariant1" class="buttons_wrapper"
                [ngClass]="braintreePayPalTokenizedPayment ? 'hidden' : ''">
                <button name="PayPal" id="order-form-paypal-button"
                  *ngIf="!isPayPalBillingAgreementApproved && (!isSubscription || !isPurchaseAvailable)"
                  [hidden]="!showPayPalPayButton" class="paypal_button" alt="PayPal" type="submit"
                  (click)="checkoutPayPalWithDifferentAddress(accountForm, diffAddress)"><img
                    *ngIf="showPayPalPayButton" src="{{ iconPaypal }}" alt="PayPal" loading="eager" fetchpriority="high" decoding="sync" /></button>
                <div [hidden]="isPayPalBillingAgreementApproved || !showAmazonButton" id="AmazonPayButton"
                  class="amazonpay_button"></div>
                <div [hidden]="braintreeHidePayPalButton || isBraintreeLoading || !braintreeEnabled" id="paypal-button">
                </div>
              </div>
            </div>

            <div [hidden]="!braintreeClientToken || paypalButtonLoaded()" class="loader"></div>

          </div>

        </section>
      </article>
    </div>
  </section>
</div>